import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import { FormGroup } from 'reactstrap';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { Input } from 'reactstrap';
import { AdditionalUserData } from '../../../globals/interfaces';
import { AddToSchema } from './AdditionalEmployeeData';

function toCamelCase(str: string): string {
    return str
        .toLowerCase()
        .split(' ')
        .map((word, index) => {
            if (index === 0) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('');
}

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    data: AdditionalUserData;
    addToSchema: AddToSchema;
}

export default function AddToSchemaModal ({
    modal,
    setModal,
    data,
    addToSchema
}: Props) {

    const [label, setLabel] = useState('');
    const schemaName = toCamelCase(label);
    const existingField = Boolean(data[schemaName]);
    const disableAdd = existingField || !label || !label.length;
    const toggle = () => setModal(!modal);

    useEffect(() => {
        setLabel('');
    }, [modal]);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add New Field</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Name of new field:</Label>
                    <Input 
                        type={'text'} 
                        value={label} 
                        onChange={(e) => setLabel(e.target.value)} 
                        className={'normal-text'}
                    />
                </FormGroup>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={existingField}>
                        {
                            existingField && (
                                <h6 className={'text-danger'}>Field already exists</h6>
                            )
                        }
                        <ActionIcon 
                            type={'save'} 
                            onClick={() => addToSchema(label, schemaName)} 
                            disabled={disableAdd}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;